var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Box from '../../Layout/Flex/Box';
const StepperStyle = styled.div `
  width: 100%;
  font-family: ${props => props.theme.fonts.fontFamily};
  position: relative;
  display: flex;
  justify-content: space-between;
`;
const StepStyle = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;
const StepNumber = styled.div `
  font-family: ${props => props.theme.fonts.fontFamily};
  display: flex;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: ${props => props.isActive || props.beenActive
    ? props.theme.utils.customBorders(props.activeColor, 2)
    : '2px solid #E0E0E0'};
  background-color: ${props => props.isActive
    ? '#fff'
    : props.beenActive ? props.theme.utils.getColor(props.activeColor) : '#E0E0E0'};
  margin-bottom: .3rem;
  z-index: 2;
  & > span {
    color: ${props => props.isActive
    ? props.theme.utils.getColor(props.activeColor)
    : props.beenActive ? '#fff' : '#222'};
    margin: auto;
    font-size: 1.2rem;
  }
`;
const TraitStyle = styled.div `
  width: 100%;
  position: absolute;
  border: ${props => props.isActive
    ? `2px dashed ${props.theme.utils.getColor(props.activeColor)}`
    : '2px dashed #E0E0E0'};
  top: 50%;
  left: 100%;
  transform: translate(-50%, -50%);
  display: flex;
  margin: 0;
`;
const Labels = styled.div `
  display: flex;
  & > div {
    flex: 1;
    text-align: center;
  }
`;
const StepLabel = styled.div `
  font-family: ${props => props.theme.fonts.fontFamily};
  color: ${props => props.isActive ? props.theme.utils.getColor(props.activeColor) : '#222'};
  font-size: .8rem;
`;
const Stepper = (_a) => {
    var { width = '100%', activeColor = 'main', currentStep, labels = [] } = _a, props = __rest(_a, ["width", "activeColor", "currentStep", "labels"]);
    const steps = [];
    labels.map((label, i) => {
        return steps.push({
            label,
            active: currentStep - 1 === i
        });
    });
    function activeStep(index) {
        const arr = steps.slice(index, steps.length);
        for (let i = 0; i < arr.length; i++) {
            if (arr[i + 1] && arr[i + 1].active) {
                return true;
            }
        }
    }
    return (_jsxs(Box, Object.assign({ column: true, width: width }, { children: [_jsx(StepperStyle, Object.assign({}, props, { children: steps.map((step, ind) => _jsxs(StepStyle, { children: [_jsx(StepNumber, Object.assign({ activeColor: activeColor, isActive: step.active, beenActive: activeStep(ind) }, { children: _jsx("span", { children: ind + 1 }) })), ind < steps.length - 1 &&
                            _jsx(TraitStyle, { activeColor: activeColor, isActive: activeStep(ind) })] }, step.label)) })), _jsx(Labels, { children: steps.map((step, ind) => _jsx("div", { children: _jsx(StepLabel, Object.assign({ activeColor: activeColor, isActive: activeStep(ind) }, { children: step.label })) }, step.label)) })] })));
};
export default Stepper;
